<template>
	<div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
		style="overflow: hidden;">
		<div class="m-portlet m-portlet--mobile">
			<PageHead label='入科管理' :label2='headtitle' url="/cycle/entry/list"></PageHead>
			<div class="m-portlet__body">
				<!--begin: Datatable -->
				<el-table :data="tableData" stripe style="width: 100%" size="medium" v-loading="loading">
					<el-table-column prop="CPStuName" label="姓名">
					</el-table-column>
					<el-table-column prop="CPStuNo" label="工号">
					</el-table-column>
					<el-table-column prop="SpecName" label="专业">
					</el-table-column>
					<el-table-column prop="SecName" label="轮转科室">
					</el-table-column>
					<el-table-column label="轮转时间" width="240">
						<template slot-scope="scope">
							{{scope.row.CPBeginDate|formatFullDate}} 至 {{scope.row.CPEndDate|formatFullDate}}
						</template>
					</el-table-column>
					<el-table-column label="状态">
						<template slot-scope="scope">
							<span v-if="scope.row.CPStatus=='1'">{{scope.row.CPStatusName}}</span>
							<span v-if="scope.row.CPStatus=='2'" style="color: green;">{{scope.row.CPStatusName}}</span>
							<span v-if="scope.row.CPStatus=='3'" style="color: red;">{{scope.row.CPStatusName}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="ExamScore" label="上一科室考核成绩"></el-table-column>
				</el-table>
				<!--end: Datatable -->
			</div>
			<div class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed">
				<div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
					<div class="m-form__actions m-form__actions--solid">
						<div class="row">
							<div class="col-lg-12 m--align-center">
								<SearchButton :url='searchUrl' ref="btnSearch" style="display: none;"></SearchButton>
								<el-button type="primary" icon="el-icon-download" @click="Out">导出</el-button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'UnEntryList',
		data() {
			return {
				condition: {
					username: '',
					rolelevel: '',
					secid: '',
					token: '',
					listtype: 'unentry',
					unentrydate: '',
					currentPage: 1,
					pageSize: 99999
				},
				loading: true,
				tableData: null,
				headtitle: '',
				searchUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/List',
				outUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/UnEntryListOut'
			}
		},
		filters: {
			formatDate(val) {
				var now = new Date(val)
				var y = now.getFullYear()
				var m = now.getMonth() + 1
				return y + '-' + (m < 10 ? '0' + m : m)
			},
			formatFullDate(val) {
				var now = new Date(val)
				var y = now.getFullYear()
				var m = now.getMonth() + 1
				var d = now.getDate()
				return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
			}
		},
		methods: {
			Out: function() {
				this.$http.post(this.outUrl, this.condition)
					.then(res => {
						if (res.data.Code === 0) {
							var filename = res.data.Data
							var url = this.$utils.Url.zpgl + '/doc/' + filename
							window.open(url)
						}
					})
					.catch(err => {
						console.log(err)
						this.$message({
							message: '导出失败',
							type: 'error'
						})
					})
			}
		},
		mounted: function() {
			this.condition.token = sessionStorage.getItem('token')
			this.condition.username = sessionStorage.getItem('username')
			this.condition.rolelevel = sessionStorage.getItem('rolelevel')
			this.condition.secid = sessionStorage.getItem('secid')
			this.condition.unentrydate = this.$route.params.entrydate
			this.headtitle = this.condition.unentrydate + ' 未入科名单'
			this.$refs.btnSearch.Search()
		}
	}
</script>

<style>
</style>
